import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	weekStartingLabel: {
		id: 'servicedesk-reports-common.table.summary-table.week-starting-label',
		defaultMessage: 'Week starting - {expandedDate}',
		description: 'Label displayed for weeks specific date range',
	},
	dateColumnLabel: {
		id: 'servicedesk-reports-common.table.summary-table.date-column-label',
		defaultMessage: 'Date',
		description: 'Header label displayed for date column',
	},
});
